import * as React from "react";

import { Button } from "semantic-ui-react";

import { TaskActionProps } from "../../model";
import { ActiveTaskAction } from "../ActiveTaskAction";

import { AdminApproveReferralReportModal } from "./AdminApproveReferralReportModal";

export const AdminApproveReferralReportButton: React.FunctionComponent<TaskActionProps> = (props) => {
    const [modalOpen, setModalOpen] = React.useState<boolean>(false);

    const openModal = React.useCallback(() => setModalOpen(true), []);

    const onCloseModal = React.useCallback(() => setModalOpen(false), []);

    return (
        <ActiveTaskAction task={props.task}>
            <Button content="Review" floated="right" onClick={openModal} />
            {modalOpen &&
                <AdminApproveReferralReportModal open onClose={onCloseModal} task={props.task} />
            }
        </ActiveTaskAction>
    );
};
